import Hero from "@/components/od/Hero";
import EditorialMarquee from "@/components/od/EditorialMarquee";
import JTBD from "@/components/od/JTBD";
import SlowDownSection from "@/components/od/SlowDownSection";
import BeforeAfterFlow from "@/components/od/BeforeAfterFlow";
import AskBusiness from "@/components/od/AskBusiness";
import Manifesto from "@/components/od/Manifesto";
import OneSourceModel from "@/components/od/OneSourceModel";
import QuietTechnology from "@/components/od/QuietTechnology";
import SocialProof from "@/components/od/SocialProof";
import FilmSection from "@/components/od/FilmSection";
import ToolsStrip from "@/components/od/ToolsStrip";
import FunnelSection from "@/components/od/FunnelSection";
import JournalSection from "@/components/od/JournalSection";
import FAQSection from "@/components/od/FAQSection";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import axios from "axios";
import { MapPin, X, ArrowRight } from "lucide-react";

function MiamiBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("od-geo-tracked")) return;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/geo`)
      .then((r) => {
        sessionStorage.setItem("od-geo-tracked", "1");
        if (r.data.miami) setShow(true);
      })
      .catch(() => {});
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="miami-geo-banner"
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="bg-brand-navy text-white"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex items-center justify-between gap-4">
            <p className="inline-flex items-center gap-2 text-sm font-medium">
              <MapPin size={14} className="text-brand-gold shrink-0" />
              Miami businesses: give your team more capacity.
            </p>
            <div className="flex items-center gap-3 shrink-0">
              <Link
                to="/miami"
                data-testid="miami-geo-banner-cta"
                className="inline-flex items-center gap-1.5 rounded-full bg-brand-teal text-white text-xs font-semibold px-4 py-2 transition-colors duration-300 hover:bg-brand-tealhover"
              >
                See how <ArrowRight size={13} />
              </Link>
              <button
                data-testid="miami-geo-banner-close"
                onClick={() => setShow(false)}
                aria-label="Dismiss"
                className="text-slate-400 hover:text-white transition-colors"
              >
                <X size={16} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default function HomePage() {
  useEffect(() => {
    document.title = "Ocean Data — Zoho Partner Montréal · More Capacity. Better Work.";
    const links = [];
    const add = (hreflang, href) => {
      const el = document.createElement("link");
      el.rel = "alternate";
      el.hreflang = hreflang;
      el.href = href;
      el.setAttribute("data-hreflang-injected", "true");
      document.head.appendChild(el);
      links.push(el);
    };
    add("en-CA", "https://oceandata.ca/");
    add("fr-CA", "https://oceandata.ca/fr/");
    add("es", "https://oceandata.ca/es/");
    add("x-default", "https://oceandata.ca/");
    return () => links.forEach((el) => el.remove());
  }, []);

  return (
    <main>
      <MiamiBanner />
      <Hero />
      <EditorialMarquee />
      <JTBD />
      <SlowDownSection />
      <BeforeAfterFlow />
      <AskBusiness />
      <Manifesto />
      <OneSourceModel />
      <QuietTechnology />
      <SocialProof />
      <FilmSection />
      <ToolsStrip />
      <FunnelSection />
      <JournalSection />
      <FAQSection />
    </main>
  );
}
